import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./packages/store/store";
import App from "./App.tsx";
import "./index.css";
import "./h5p.css";
import { initializeApp } from "firebase/app";
import ReactGA from "react-ga4";
import { PostHogProvider } from "posthog-js/react";
import * as Sentry from "@sentry/react";
import { getEnvironment } from "@packages/utils/index.tsx";

// Inject Prodiax tracking script
(function () {
  const script = document.createElement("script");
  script.src =
    "https://unpkg.com/prodiax-tracking-sdk@latest/dist/prodiax-sdk.min.js";
  script.async = true;
  script.onload = function () {
    // @ts-ignore
    if (window.Prodiax && typeof window.Prodiax.init === "function") {
      // @ts-ignore
      window.Prodiax.init({
        productId: "madlen.io_a76395ec41804e13a39cb84e",
      });
    }
  };
  document.head.appendChild(script);
})();

const firebaseConfig = {
  apiKey: "AIzaSyDc7kG7xHXYDJqMO2oFeSLWRG8hxBnJHm8",
  authDomain: "madlen-mobile.firebaseapp.com",
  projectId: "madlen-mobile",
  storageBucket: "madlen-mobile.appspot.com",
  messagingSenderId: "578850801509",
  appId: "1:578850801509:web:f009ea9786a5853ecfc38c",
  measurementId: "G-S6DRMDM17K",
};

ReactGA.initialize("G-59CM727ZWZ");

if (getEnvironment() === "PROD") {
  Sentry.init({
    dsn: "https://14cad9b3cab8e2442891070ddd567101@o4506982877888512.ingest.us.sentry.io/4508938012065792",
  });
}

// Initialize Firebase
initializeApp(firebaseConfig);

// function injectReactScanScript() {
//   if (getEnvironment() === "DEV") {
//     const script = document.createElement("script");
//     script.src = "//unpkg.com/react-scan/dist/auto.global.js";
//     script.crossOrigin = "anonymous";
//     script.async = true;
//     document.head.appendChild(script);
//   }
// }

// injectReactScanScript();

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PostHogProvider
      apiKey="phc_LMFS9frKT6NKbqxPFfaEEwkJb7ll4oyd3e93x9UsrFc"
      options={{
        api_host: "https://d2ozkoudu4851u.cloudfront.net",
        person_profiles: "identified_only",
        before_send: (event) => {
          // if localhost, don't send event
          if (window.location.hostname === "localhost") {
            return null;
          }
          return event;
        },
      }}
    >
      <App />
    </PostHogProvider>
  </Provider>,
);
